import TitleUpdater from "../../components/shared/title/TitleUpdater";
import styles from "./Innovations.module.scss";
import { useEffect, useRef, useState } from "react";
import { InnovationDataType } from "../../interface/site.interface";
import { InnovationServices } from "../../services/innovation.service";
import arrow_right from "../../../src/assets/images/pages/home/locations/Vector.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useLang } from "../../hooks/useLangPath";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import Spinner from "../../components/shared/spinner/Spinner";

const Innovations = () => {
  const swiperRef = useRef<any>(null);
  const lang = useLang();
  const language = useSelector((state: RootState) => state.language.language);
  const { data } = useSelector((state: RootState) => state.translationData);

  const [innovationData, setInnovationData] = useState<InnovationDataType[]>(
    []
  );
  const [loading, setLoading] = useState(true);


  // const handleNext = () => {
  //   const swiper = swiperRef.current?.swiper;
  //   if (!swiper) return;

  //   if (swiper.isEnd && paginationData.next_page_url) {
  //     fetchData(paginationData.next_page_url);
  //     setTimeout(() => swiper.slideTo(0), 100);
  //   } else {
  //     swiper.slideNext();
  //   }
  // };

  // const handlePrev = () => {
  //   const swiper = swiperRef.current?.swiper;
  //   if (!swiper) return;

  //   if (swiper.isBeginning && paginationData.prev_page_url) {
  //     fetchData(paginationData.prev_page_url);
  //     setTimeout(() => swiper.slideTo(innovationData.length - 1), 100);
  //   } else {
  //     swiper.slidePrev();
  //   }
  // };

  // Bu hissələrdə dəyişiklik etdik:
  const handlePrev = () => {
    swiperRef.current?.swiper?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.swiper?.slideNext();
  };

  const fetchData = async (url: string) => {
    setLoading(true);
    try {
      const response = await InnovationServices.GetInnovations(url);
      setInnovationData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching innovations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("/innovations?page=1");
  }, [language]);

  return (
    <div id={styles.innovations_page}>
      {!/^\/(az|en|ru)\/?$/.test(window.location.pathname) && (
        <TitleUpdater
          title={
            data?.colibri && data?.updates
              ? `${data?.colibri} | ${data?.updates}`
              : "Colibri"
          }
        />
      )}
      <div className="container">
        <div id={styles.locations_section}>
          <div className={styles.Swiper_Section}>
            <h1 style={{ textAlign: "center" }} className={styles.page_title}>
              {data?.updates}
            </h1>
            <div className={styles.locations_section}>
              <div className={styles.section_head}>
                <div className={styles.next_prev_buttons}>
                  <button
                    onClick={handlePrev}
                    //                    disabled={
                    //   !swiperRef.current?.swiper ||
                    //   (!paginationData.prev_page_url &&
                    //     swiperRef.current.swiper.isBeginning)
                    // }
                    className={styles.prev_btn}
                  >
                    <img src={arrow_right} alt="prev" />
                  </button>
                  <button
                    onClick={handleNext}
                    //                    disabled={
                    //   !swiperRef.current?.swiper ||
                    //   (!paginationData.next_page_url &&
                    //     swiperRef.current.swiper.isEnd)
                    // }
                    className={styles.next_btn}
                  >
                    <img src={arrow_right} alt="next" />
                  </button>
                </div>
              </div>

              {loading ? (
                <div className={styles.loadingWrapper}>
                  <Spinner size="large" />
                </div>
              ) : innovationData.length === 0 ? (
                <div className={styles.empty}>
                  {data?.auth_common_order_history_empty}
                </div>
              ) : (
                <Swiper
                  ref={swiperRef}
                  className={styles.mySwiper}
                  slidesPerView={"auto"}
                  spaceBetween={24}
                  loop={true}
                  breakpoints={{
                    1680: { slidesPerView: 3.1 },
                    1300: { slidesPerView: 3 },
                    994: { slidesPerView: 2.5 },
                    576: { slidesPerView: 1 },
                    0: { slidesPerView: 1 },
                  }}
                >
                  {innovationData.map((loc, idx) => (
                    <SwiperSlide key={idx} className={styles.swiperSlide}>
                      <Link to={`/${lang}/${loc.url}`}>
                        <div className={styles.location_card}>
                          <img
                            src={`https://backend.colibri.az${loc.image}`}
                            alt={loc.title}
                          />
                          <div className={styles.overlay}>
                            <p>{loc.title}</p>
                          </div>
                        </div>
                      </Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Innovations;
